<template lang="pug">
  v-snackbar(
    v-model="show" 
    :color="color"
    :timeout="timeout"
    bottom
  ) {{ message }}
</template>

<script>
export default {
  data () {
    return {
      show: false,
      message: '',
      color: '',
      timeout: 6000
    }
  },

  created () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showMessage') {
        this.message = state.snackbarMessage
        this.color = state.snackbarColor
        this.show = true
      }
    })
  }
}
</script>